// Egy terület MEGJELENÉSE: ikon + akcentszín, amit az adminok állítanak be.
//
// TÁROLÁS — ÁTMENETI MEGOLDÁS, DOKUMENTÁLVA:
// Az Odin `knowledge.spaces` sémájában ma egyetlen megjelenés-mező van, az `icon?` (szabad szöveg,
// 60 karakter). Színnek nincs mezője. Amíg a platform-csapat fel nem veszi (kérés rögzítve a
// egy korábbi platform-döntésben), a kettőt EGY mezőben tároljuk `"<ikon>:<szín>"` alakban.
//
// Ezért van ez a fájl: a kódolás EGY helyen él, nevesített értékekkel (nem index-szel, hogy a
// paletta átrendezése ne írja át a jelentést), teszttel körbevéve. Amikor megjön az `accent` mező,
// a migráció ennyi: a `parse` mindkét formát elfogadja, a `format` már csak az ikont adja.
//
// Ismeretlen érték SOHA nem hiba: a régi tartalom `icon`-ja tetszőleges string lehet (a BookStack
// nem hozott ikont, de kézzel bármit be lehetett írni), ilyenkor a felület a nevéből következtet.
/** Az akcentek nevesítve — a `--topic` CSS-változó két tónusát a web oldja fel. */
export const ACCENTS = [
    'green',
    'teal',
    'ocean',
    'indigo',
    'plum',
    'olive',
    'amber',
    'terracotta',
];
/**
 * A választható ikonok — heroicons-nevek kebab-case-ben (`BookOpenIcon` → `book-open`).
 * Szűk, szándékosan: egy tudástárban a felismerhetőség számít, nem a választék.
 */
export const SPACE_ICONS = [
    'book-open',
    'code-bracket',
    'lifebuoy',
    'document-duplicate',
    'envelope',
    'megaphone',
    'ticket',
    'heart',
    'calendar-days',
    'chart-bar',
    'users',
    'briefcase',
    'clipboard-document-list',
    'scale',
    'sparkles',
    'rectangle-stack',
];
const EMPTY = { icon: null, accent: null };
export function parseAppearance(raw) {
    if (!raw)
        return EMPTY;
    const [icon, accent] = raw.trim().split(':');
    return {
        icon: isSpaceIcon(icon) ? icon : null,
        accent: isAccent(accent) ? accent : null,
    };
}
/** Üres stringet ad, ha semmi nincs beállítva — a mező így „nincs megadva"-ként megy a buszra. */
export function formatAppearance(appearance) {
    if (!appearance.icon && !appearance.accent)
        return '';
    // Szín önmagában is tárolható: az ikon helye ilyenkor üresen marad („:teal").
    return `${appearance.icon ?? ''}:${appearance.accent ?? ''}`.replace(/:$/, '');
}
/** A BFF ezzel utasítja vissza a szemetet: minden nem üres értéknek értelmezhetőnek kell lennie. */
export function isValidAppearance(raw) {
    if (raw === '')
        return true;
    const [icon, accent, ...rest] = raw.split(':');
    if (rest.length > 0)
        return false;
    if (icon !== '' && !isSpaceIcon(icon))
        return false;
    if (accent !== undefined && accent !== '' && !isAccent(accent))
        return false;
    return true;
}
function isSpaceIcon(value) {
    return value !== undefined && SPACE_ICONS.includes(value);
}
function isAccent(value) {
    return value !== undefined && ACCENTS.includes(value);
}
//# sourceMappingURL=appearance.js.map